(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-free-shipping-progress"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('free-shipping-progress')) {
    class FreeShippingProgress extends HTMLElement {
      connectedCallback() {
      this.listenerController?.abort();
        this.listenerController = new AbortController();

        if (!FreeShippingProgress.instances) {
          FreeShippingProgress.instances = new Map();
        }

        this.instanceKey = this.dataset.instanceKey;
        const previousInstance = FreeShippingProgress.instances.get(this.instanceKey);

        if (previousInstance && previousInstance !== this && previousInstance.isConnected) {
          previousInstance.remove();
        }

        FreeShippingProgress.instances.set(this.instanceKey, this);

        this.threshold = Number(this.dataset.threshold);
        this.currentVariantId = this.dataset.variantId;
        this.moneyFormat = this.dataset.moneyFormat;
        this.variantPrices = JSON.parse(this.querySelector('[data-variant-prices]').textContent);
        this.track = this.querySelector('[data-progress-track]');
        this.bar = this.querySelector('[data-progress-bar]');
        this.scope = this.closest('.shopify-section, [id^="shopify-section-"]') || document;
        this.syncMessageElements();

        this.attributeObserver?.disconnect();
        this.attributeObserver = new MutationObserver(() => {
          cancelAnimationFrame(this.attributeUpdateFrame);
          this.attributeUpdateFrame = requestAnimationFrame(() => {
            this.currentQuantity = null;
            this.update();
          });
        });
        this.attributeObserver.observe(this, {
          attributes: true,
          attributeFilter: [
            'data-threshold',
            'data-money-format',
            'data-success-text',
            'data-progress-text',
          ],
        });

        this.handleInput = (event) => {
          if (
            event.type.includes('variant') ||
            event.type === 'quantity-selector:update' ||
            event.target?.matches?.('input[name="quantity"], input[name="id"], input[type="radio"], select')
          ) {
            if (event.type === 'quantity-selector:update') {
              const eventQuantity = Number(event.detail?.quantity);

              if (Number.isFinite(eventQuantity) && eventQuantity > 0) {
                this.currentQuantity = eventQuantity;
              }
            } else if (event.target?.matches?.('input[name="quantity"]')) {
              const inputQuantity = Number(event.target.value);

              if (Number.isFinite(inputQuantity) && inputQuantity > 0) {
                this.currentQuantity = inputQuantity;
              }
            }

            if (event.type.includes('variant')) {
              this.currentQuantity = null;
            }

            cancelAnimationFrame(this.updateFrame);
            this.updateFrame = requestAnimationFrame(() => {
              this.syncVariantFromForm();
              this.update();
            });
          }
        };

        this.handleProductSelect = (event) => {
          this.currentQuantity = null;

          if (!event.promise?.then) {
            requestAnimationFrame(() => this.update());
            return;
          }

          event.promise
            .then((payload) => {
              const detail = payload?.detail;
              const variant = detail?.resource || payload?.variant;

              if (detail?.productId && String(detail.productId) !== this.dataset.productId && !detail.newProduct) {
                return;
              }

              if (variant?.id) {
                this.currentVariantId = String(variant.id);

                const price =
                  typeof variant.price === 'object'
                    ? Math.round(Number(variant.price.amount) * 100)
                    : Number(variant.price);

                if (Number.isFinite(price)) {
                  this.variantPrices[this.currentVariantId] = price;
                }
              }

              this.update();
            })
            .catch(() => {});
        };

       const listenerOptions = { signal: this.listenerController.signal };

        this.scope.addEventListener('input', this.handleInput, listenerOptions);
        this.scope.addEventListener('change', this.handleInput, listenerOptions);
        this.scope.addEventListener('quantity-selector:update', this.handleInput, listenerOptions);
        this.scope.addEventListener('shopify:product:select', this.handleProductSelect, listenerOptions);
        this.scope.addEventListener('variant:update', this.handleInput, listenerOptions);
        this.scope.addEventListener('variant:change', this.handleInput, listenerOptions);
        this.scope.addEventListener('product:variant-change', this.handleInput, listenerOptions);
        this.update();
      }

      disconnectedCallback() {
        this.listenerController?.abort();
        this.attributeObserver?.disconnect();
        cancelAnimationFrame(this.updateFrame);
        cancelAnimationFrame(this.attributeUpdateFrame);

        if (FreeShippingProgress.instances?.get(this.instanceKey) === this) {
          FreeShippingProgress.instances.delete(this.instanceKey);
        }
      }

      syncMessageElements() {
        this.messageContainer = this.querySelector('.product-free-shipping-progress__message');
        if (!this.messageContainer) {
          this.icon = null;
          this.message = null;
          return;
        }

        this.icon = this.messageContainer.querySelector('.product-free-shipping-progress__icon');
        this.message = this.messageContainer.querySelector('[data-progress-message]');
      }

      get quantity() {
        if (Number.isFinite(this.currentQuantity) && this.currentQuantity > 0) {
          return this.currentQuantity;
        }

        const input = this.scope.querySelector('input[name="quantity"]');
        return Math.max(1, Number(input?.value) || 1);
      }

      get variantPrice() {
        const variantInput = this.scope.querySelector('form[action*="/cart/add"] input[name="id"]');
        const selectedVariantId = this.currentVariantId || variantInput?.value;
        const selectedPrice = this.variantPrices[selectedVariantId];
        return Number(selectedPrice ?? Object.values(this.variantPrices)[0] ?? 0);
      }

      syncVariantFromForm() {
        const variantInput = this.scope.querySelector('form[action*="/cart/add"] input[name="id"]');

        if (variantInput?.value && this.variantPrices[variantInput.value] !== undefined) {
          this.currentVariantId = variantInput.value;
        }
      }

      update() {
        const latestThreshold = Number(this.dataset.threshold);

        if (!Number.isFinite(latestThreshold) || latestThreshold <= 0) return;

        this.threshold = latestThreshold;
        this.moneyFormat = this.dataset.moneyFormat;
        this.track = this.querySelector('[data-progress-track]');
        this.bar = this.querySelector('[data-progress-bar]');

        this.syncMessageElements();

        if (!this.bar || !this.track || !this.message) return;

        const total = this.variantPrice * this.quantity;
        const remaining = Math.max(0, this.threshold - total);
        const progress = Math.min(100, Math.round((total / this.threshold) * 100));

        this.bar.style.setProperty('--free-shipping-progress', `${progress}%`);
        this.track.setAttribute('aria-valuenow', progress);
        this.classList.toggle('is-qualified', remaining === 0);
        this.message.textContent =
          remaining === 0
            ? this.dataset.successText
            : this.dataset.progressText.replace('[amount]', this.formatMoney(remaining));
      }

      formatMoney(cents) {
        const format = this.moneyFormat || '';
        const match = format.match(/\{\{\s*(\w+)\s*\}\}/);

        if (!match) return `$${(cents / 100).toFixed(2)}`;

        const placeholder = match?.[1] || 'amount';
        const useDecimals = !placeholder.includes('no_decimals');
        const useCommaDecimal = placeholder.includes('comma_separator');
        const useApostrophe = placeholder.includes('apostrophe_separator');
        const useSpace = placeholder.includes('space_separator');
        const decimalMark = useCommaDecimal ? ',' : '.';
        const thousandsMark = useCommaDecimal ? '.' : useApostrophe ? "'" : useSpace ? ' ' : ',';
        const value = (cents / 100).toFixed(useDecimals ? 2 : 0);
        const parts = value.split('.');

        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsMark);
        const formatted = useDecimals ? `${parts[0]}${decimalMark}${parts[1]}` : parts[0];

        return format.replace(match[0], formatted);
      }
    }

    customElements.define('free-shipping-progress', FreeShippingProgress);
  }
  } catch(e) { console.error(e); }
})();

})();
